import { BorderBox } from "../components/index.js";

export default function Privacy() {
  return (
    <div className={`flex flex-col justify-between h-[calc(100vh-4rem)] pb-4`}>
      <BorderBox padding="p-8" overflow>
        <h1 className="text-lz-ink-mid dark:text-lz-concrete text-5xl mb-6">
          Privacy Policy
        </h1>
        <div className="flex flex-col gap-y-4 text-lz-ink-mid dark:text-lz-concrete text-lg">
          <p>
            Just think about these things in your mind and drop em&apos; on canvas.
            The more we do this - the more it will do good things to our heart.
            This is probably the greatest thing that&apos;s ever happened in my life.
          </p>

          <p>
            A fan brush can be your best friend. I thought today we would make a
            happy little stream that&apos;s just running through the woods here. Nice
            little clouds playing around in the sky.
          </p>

          <p>
            No worries. No cares. Just float and wait for the wind to blow you
            around. Almost everything is going to happen for you automatically -
            you don&apos;t have to spend any time working or worrying. We touch the
            canvas, the canvas takes what it wants. Son of a gun. With something
            so strong, a little bit can go a long way. These little son of a
            guns hide in your brush and you just have to push them out.
          </p>

          <p>
            There it is. Painting should do one thing. It should put happiness
            in your heart. Let&apos;s put some happy little clouds in our world. It&apos;s
            amazing what you can do with a little love in your heart. I really
            recommend you use odorless thinner or your spouse is gonna run you
            right out into the yard and you&apos;ll be working by yourself.
          </p>

          <p>
            We have no limits to our world. We&apos;re only limited by our
            imagination. Here we&apos;re limited by the time we have. Anytime you
            learn something your time and energy are not wasted. Without washing
            the brush, I&apos;m gonna go right into some Van Dyke Brown, some Burnt
            Umber, and a little bit of Sap Green. Working it up and down, back
            and forth.
          </p>

          <p>
            You could sit here for weeks with your one hair brush trying to do
            that - or you could do it with one stroke with an almighty brush.
            Let that brush dance around there and play. You can get away with a
            lot. Nothing&apos;s gonna make your husband or wife madder than coming
            home and having a snow-covered dinner. Life is too short to be
            alone, too precious. Share it with a friend.
          </p>

          <p>
            You have freedom here. The only guide is your heart. Don&apos;t hurry.
            Take your time and enjoy. Only eight colors that you need. Water&apos;s
            like me. It&apos;s laaazy ... Boy, it always looks for the easiest way to
            do things There&apos;s nothing wrong with having a tree as a friend.
            Maybe he has a little friend that lives right over here.
          </p>

          <p>
            Let&apos;s make some happy little clouds in our world. See how easy it is
            to create a little tree right in your world. Get away from those
            little Christmas tree things we used to make in school. Use what you
            see, don&apos;t plan it. You need to have a very firm paint to do this. I
            was blessed with a very steady hand; and it comes in very handy when
            you&apos;re doing these little delicate things.
          </p>

          <p>
            We don&apos;t have anything but happy trees here. The only prerequisite
            is that it makes you happy. If it makes you happy then it&apos;s good.
            Just let these leaves jump off the brush You can do it.
          </p>

          <p>
            Maybe we got a few little happy bushes here, just covered with snow.
            Van Dyke Brown is a very nice brown, it&apos;s almost like a chocolate
            brown. Just make a decision and let it go. Trees grow in all kinds
            of ways. They&apos;re not all perfectly straight. Not every limb is
            perfect.
          </p>
        </div>
      </BorderBox>
    </div>
  );
}
